// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"368":"2ab40343","582":"3a575468"}[chunkId] + ".chunk.css";
};